import { Typography, Stack, useMediaQuery, Tooltip, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'
import dayjs from 'dayjs'
import Logo from '../../components/Logo/Logo'
import GoogleLoginButton from './GoogleLoginButton'
import LoginCarousel from './LoginCarousel'
import UserService from '../../store/services/UserService'
import { useNavigate } from 'react-router-dom'
import navigation from '../../config/navigation'
import { StyledContainerRowCenter } from '../../styles/ContainerStyles'
import DarkModeButton from '../../components/Button/DarkModeButton'
import { StyledListItemButton } from '../../styles/SidebarStyles'

const LoginView = () => {
  const { t } = useTranslation()
  const { i18n } = useTranslation()
  const storedLanguage = localStorage.getItem('language')
  const initialLanguage = storedLanguage || 'pl'
  const [language, setLanguage] = useState(initialLanguage)
  const navigate = useNavigate()

  useEffect(() => {
    i18n.changeLanguage(initialLanguage).then()
    dayjs.locale(initialLanguage)
  }, [i18n, initialLanguage])

  const theme = useTheme()
  const isMd = useMediaQuery(theme.breakpoints.up('smMid'))

  useEffect(() => {
    if (UserService.isLoggedIn() && !UserService.isTokenExpired()) {
      navigate(navigation.home)
    }
  }, [navigate])

  const changeLanguage = () => {
    const newLanguage = language === 'en' ? 'pl' : 'en'
    setLanguage(newLanguage)
    i18n.changeLanguage(newLanguage).then()
    dayjs.locale(newLanguage)
    localStorage.setItem('language', newLanguage)
  }

  return (
    <Stack direction="row" sx={{ bgcolor: 'background.main', height: '100vh', color: 'text.base' }}>
      <Stack sx={{ position: 'absolute', top: 64, left: '10%', height: 'auto', width: 150 }}>
        <Logo />
      </Stack>
      <Stack width="100%" direction="column" height="100%" justifyContent="center" paddingLeft="10%" gap="48px">
        <Stack direction="column" gap="24px">
          <Typography variant="h2" component="h1" sx={{ color: 'text.highEmphasis' }}>
            {t('page.login.welcomeMessage')}
          </Typography>
          <Typography width={250}>{t('page.login.loginViewDescription1')}</Typography>
        </Stack>
        <GoogleLoginButton />

        <Stack
          direction="row"
          justifyContent="center"
          gap={0.5}
          sx={{
            position: 'absolute',
            bottom: 64,
            left: '10%',
            height: 'auto',
            width: 'auto',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Tooltip title={t('language')} placement="top">
            <StyledListItemButton onClick={() => changeLanguage()} sx={{ p: 1 }}>
              <Typography
                variant="button"
                sx={{
                  color: 'text.base',
                  cursor: 'pointer',
                  '&:hover': {
                    textDecoration: 'underline',
                  },
                  display: 'inline-block',
                }}
                onClick={() => changeLanguage()}
              >
                {t('languageShort')}
              </Typography>
            </StyledListItemButton>
          </Tooltip>
          <StyledContainerRowCenter>
            <DarkModeButton />
          </StyledContainerRowCenter>
        </Stack>
      </Stack>
      {isMd && (
        <Stack width="100%" direction="column" sx={{ bgcolor: 'background.main', p: 4 }}>
          <LoginCarousel />
        </Stack>
      )}
    </Stack>
  )
}

export default LoginView
